[
  "NVMe",
  "SATA",
  "M.2",
  "U.2",
  "SAS",
  "HDD",
  "SSD",
  "PCIe 3.0",
  "PCIe 4.0",
  "PCIe 5.0"
]
